module.exports = __webpack_public_path__ + "img/03.3d3d5231.png";